import store from "@/store";
import { Route, RawLocation } from "vue-router";

export class RouteSwitch {
  private static instance: RouteSwitch | null = null;

  public static getInstance(): RouteSwitch {
    if (!RouteSwitch.instance) {
      RouteSwitch.instance = new RouteSwitch();
    }

    return RouteSwitch.instance;
  }

  get homeRoute(): string {
    return store.getters["authModule/homeRoute"];
  }

  get etl(): boolean {
    return store.getters["flowModule/etl"];
  }

  get flowRoute(): string {
    return store.getters["flowModule/goto"];
  }

  public getRoute(): string {
    return this.flowRoute;
  }

  public async next(
    to: Route,
    from: Route,
    next: (to?: RawLocation) => void
  ): Promise<void> {
    await this.checkFlow();

    if (this.etl) {
      this.flowRoute === to.path ? next() : next(this.flowRoute);
    } else if (to.name === "root") {
      next(this.homeRoute);
    } else {
      next();
    }
  }

  private async checkFlow(): Promise<void> {
    await store.dispatch("flowModule/checkFlow");
  }
}

export default RouteSwitch.getInstance();
